const Recruitment = () => {
  return (
    <section id="recruitment" className="relative py-0 overflow-hidden">
      <div className="relative w-full h-[360px] sm:h-[420px] md:h-[480px] lg:h-[520px]">
        {/* 背景画像 */}
        <img
          src="/image/recruitment1.jpg"
          alt="採用情報 - 株式会社MSKで一緒に働きませんか"
          title="採用情報 - 株式会社MSK"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-transparent"></div>

        {/* コンテンツ */}
        <div className="absolute inset-0 flex items-center">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10 w-full">
            <div className="max-w-xl">
              <p className="text-white text-xs font-semibold tracking-[0.25em] uppercase mb-3 md:mb-4 font-['Inter']">
                Recruitment
              </p>
              <h4 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-3 md:mb-4 leading-snug">
                あなたの「成長したい」を<br />
                全力で応援します。
              </h4>
              <p className="text-white/80 text-xs sm:text-sm leading-[1.9] mb-5 md:mb-8">
                株式会社MSKでは、共に成長し、社会に貢献できる仲間を募集しています。<br className="hidden sm:inline" />
                経験・未経験を問わず、「人に必要とされる人」を目指す方を歓迎します。
              </p>
              <a
                href="/recruit"
                className="inline-flex items-center gap-2 px-8 py-4 bg-[#89B56B] text-white text-sm font-bold rounded-full hover:bg-[#5DAA68] transition-all duration-300 whitespace-nowrap shadow-lg cursor-pointer"
              >
                採用情報を見る
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Recruitment;
